import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const links = [
  { label: "Produkty", id: "produkty", key: TESTIDS.nav.linkProducts },
  { label: "O mnie", id: "o-mnie", key: TESTIDS.nav.linkAbout },
  { label: "FAQ", id: "faq", key: TESTIDS.nav.linkFaq },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 px-5 sm:px-8 py-4"
    >
      <div
        className={`mx-auto max-w-6xl flex items-center justify-between rounded-full px-5 sm:px-6 py-3 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${
          scrolled ? "bg-white/70 backdrop-blur-xl shadow-[0_8px_30px_rgb(0,0,0,0.05)]" : "bg-transparent"
        }`}
      >
        <button
          data-testid={TESTIDS.nav.logo}
          onClick={() => scrollTo("hero")}
          className="flex items-center gap-2 font-display font-700 text-lg text-ink"
        >
          <span className="grid place-items-center h-8 w-8 rounded-full bg-violet text-white">
            <Sparkles size={16} />
          </span>
          Justyna<span className="text-violet-deep"> Skowrońska</span>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.key}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-500 text-ink/70 hover:text-violet-deep transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          data-testid={TESTIDS.nav.cta}
          onClick={() => scrollTo("produkty")}
          className="rounded-full bg-ink text-white text-sm font-500 px-5 py-2.5 hover:bg-violet-deep transition-colors duration-300"
        >
          Przejdź do sklepu
        </button>
      </div>
    </motion.nav>
  );
};
